import { LoadingPage } from 'components/features';
import { ENDPOINTS } from './endpoints';
import { lazy } from 'react';

export interface MenuRoute {
  path: string;
  component: any;
  role?: any[];
  children?: MenuRoute[];
}

const LandingPage = LoadingPage(lazy(() => import('pages/landing/landing-page')));
const NotFoundPage = LoadingPage(lazy(() => import('pages/feedback/not-found')));
const AboutUsPage = LoadingPage(lazy(() => import('pages/about-us/about-us-page')));
// const MissionVisionPage = LoadingPage(lazy(() => import('pages/mission-vision/mission-vision-page')));
const OurTeamPage = LoadingPage(lazy(() => import('pages/our-team/our-team-page')));
const GetInTouchPage = LoadingPage(lazy(() => import('pages/get-in-touch/get-in-touch-page')));
const MediaGalleryPage = LoadingPage(lazy(() => import('pages/media-gallery/media-gallery-page')));
const TrainingPage = LoadingPage(lazy(() => import('pages/training/training-page')));
const RecruitmentPage = LoadingPage(lazy(() => import('pages/recruitment/recruitment-page')));

// const OurValuePage = LoadingPage(lazy(() => import('pages/our-value/our-value-page')));
const SustainabilityPage = LoadingPage(lazy(() => import('pages/sustainability/sustainability-page')));
// const SampleMenuPage = LoadingPage(lazy(() => import('pages/sample-menu/sample-menu-page')));
const OurServicePage = LoadingPage(lazy(() => import('pages/our-service/our-service-page')));
const CareerPage = LoadingPage(lazy(() => import('pages/career/career-page')));

const NewsAnnouncementPage = LoadingPage(lazy(() => import('pages/news-announcement/news-announcement-page')));
const NewsNestedPage = LoadingPage(lazy(() => import('pages/news-announcement/news-nested-page')));
const AchievementsPage = LoadingPage(lazy(() => import('pages/achievements/achievements-page')));

export const publicRoutes: MenuRoute[] = [
  {
    path: ENDPOINTS.notFound,
    component: NotFoundPage,
  },
  {
    path: '*',
    component: NotFoundPage,
  },
];

export const mainRoutes: MenuRoute[] = [
  {
    path: ENDPOINTS.home,
    component: LandingPage,
  },
  {
    path: ENDPOINTS.aboutUs,
    component: AboutUsPage,
  },
  // {
  //   path: ENDPOINTS.missionVision,
  //   component: MissionVisionPage,
  // },
  {
    path: ENDPOINTS.ourTeam,
    component: OurTeamPage,
  },
  {
    path: ENDPOINTS.getInTouch,
    component: GetInTouchPage,
  },
  {
    path: ENDPOINTS.mediaGalery,
    component: MediaGalleryPage,
  },
  {
    path: `${ENDPOINTS.news}/:key`,
    component: NewsNestedPage,
  },
  {
    path: ENDPOINTS.news,
    component: NewsAnnouncementPage,
  },
  // {
  //   path: ENDPOINTS.ourValue,
  //   component: OurValuePage,
  // },
  {
    path: ENDPOINTS.sustainability,
    component: SustainabilityPage,
  },
  // {
  //   path: ENDPOINTS.sampleMenu,
  //   component: SampleMenuPage,
  // },
  {
    path: ENDPOINTS.services,
    component: OurServicePage,
  },
  {
    path: ENDPOINTS.training,
    component: TrainingPage,
  },
  {
    path: ENDPOINTS.recruitment,
    component: RecruitmentPage,
  },
  {
    path: ENDPOINTS.career,
    component: CareerPage,
  },
  {
    path: ENDPOINTS.achievements,
    component: AchievementsPage,
  },
];

export const privateRoutes = [];
